import React, { useState, useEffect } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
// import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

//Redux
import { useSelector, useDispatch } from "react-redux";
import { getGoodsReceivedNote } from "../../../../redux/feature/supplier_app/purchasingSlice";

//API
import ItemService from "../../../../services/supplier_appCommonService";
import CustomerService from "../../../../services/customer_v2_appCommonService";

//Components
import Layout from "../../../../Layout/Layout";
import { InputField } from "../../../../Components/formElements/InputField";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import Constants from "../../../../common/SupplierConstants";
import POCollabrationCommonFillter from "../../../../Components/Filter/POCollabration/POCollabrationCommonFillter";
import SuccessRegisterModal from "../../../../Components/SuccessRegisterModal";
import { currencyFormat,   } from "../../../../common/Validations";
import FileViewerModalForHB from "../../../../Components/FileViewer/FileViewerModalForHB";
import FileUploadComponentForHB from "../../../../Components/formElements/FileUploadComponentForHB";
import HeaderText from "../../../../Components/Modal/supplier_app/PO_Collabration/HeaderText";
import CustomerConstants from "../../../../common/CustomerConstants";
import FileUploadComponent from "../../../../Components/formElements/FileUploadComponent";
// import { Construction } from "lucide-react";

const CreateGRN = () => {
  // eslint-disable-next-line
  const dispatch = useDispatch();
  // const navigate = useNavigate();
  localStorage.setItem("menu", "Purchasing");
  localStorage.setItem("submenu", "Create GRN");

  let selectedPoDetails = useSelector(
    (state) => state?.purchasing?.purchase_order?.selectedPoDetails
  ); // selectedPoDetails Details from Store

  let poNumber = useSelector(
    (state) => state?.purchasing?.purchase_order?.poNumber
  ); // purchase_order from Store

  let subTransactionActivity = useSelector(
    (state) => state?.purchasing?.goods_received_note?.subTransactionActivity
  ); // User Details from Store
  // console.log(">>subTransactionActivity",subTransactionActivity)

  let asnNumber = useSelector(
    (state) => state?.purchasing?.goods_received_note?.asnNumber
  ); // User Details from Store

  let asn_data = useSelector((state) => state?.purchasing?.asn?.data); // asn data Details from Store

  const modalData = {
    title: "GRN Creation",
    successMsg: "",
  };
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  // eslint-disable-next-line
  const [getModalInfo, setModalInfo] = useState(modalData);
  const [disabled, setDisabled] = useState(false);
  const [getHeaderData, setHeaderData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [itemTableData, setItemTableData] = useState([]);
  const [subTotalValue, setSubTotalValue] = useState(0);
// console.log(">>getHeaderData",getHeaderData)

  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);

  // View attachment files
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);
  const [getOtherChargesValue, setOtherChargesValue] = useState(0);

  const handleAttachmentDeleted = ({
    attachmentId,
    hasFiles,
    remainingCount,
  }) => {
    if (hasFiles && remainingCount === 0) {
      setFormInputs((prev) => ({
        ...prev,
        shippingDocuments: "",
        otherAttachments: "",
      }));
    }
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };

  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
    // console.log("onInputChange => formInputs", formInputs);
  };

// eslint-disable-next-line
  const normalizedTableData = itemTableData.map((item) => ({
  ...item,
  rejectedQuantity: item.rejectedQuantity ?? 0,
  rejectedRemarks: item.rejectedRemarks ?? "",
}));

const handleRejectedChange = (localId, field, value) => {
  setItemTableData((prev) =>
    prev.map((item) => {
      if (item.local_id !== localId) return item;

      // If rejectedQuantity changed to 0 → clear remarks
      if (field === "rejectedQuantity" && Number(value) === 0) {
        return {
          ...item,
          rejectedQuantity: 0,
          rejectedRemarks: "",
        };
      }

      return {
        ...item,
        [field]: value,
      };
    })
  );
};

//   const handleRejectedChange = (localId, field, value) => {
//   setFormInputs((prev) => ({
//     ...prev,
//     items: prev.items.map((item) =>
//       item.local_id === localId
//         ? { ...item, [field]: value }
//         : item
//     ),
//   }));
// };

  const [formInputs, setFormInputs] = useState({
    subTransactionActivity: subTransactionActivity,
    documentType: "GRN",
    transactionActivity: "GRN",
    purchasingDocumentNr: poNumber,
    purchasingDocumentDate: "",
    grnStatusHeader: "Created",
    grnStatus: "",
    grnDate: "",
    despatchNr: "",
    despatchDate: "",
    vendorCode: "",
    vendorName: "",
    shippingType: "",
    grnRemark: "",
    grnCount: "1",
    purchasingDocumentValue: "",
    deliveredValue: "",
    deliveredStatus: "",
    invoicedValue: "",
    invoicedStatus: "",
    paidValue: "",
    currency: "",
    currencyCode: "",
    paymentTerms: "",
    deliveryNoteNr: "",
    billOfLading: "",
    incoTerms: "",
    vendorInvoiceNo: "",
    vendorInvoiceDate: "",
    vendorBasicValue: "",
    vendorTaxValue: "",
    vendorOtherChargesValue: "",
    vendorTotalInvoiceValue: "",
    vendorInvoiceCurrency: "",
    gstValue: "",
    items: [
      {
        grnItemNr: "",
        materialCode: "",
        materialDescription: "",
        purchaseQuantity: "",
        grnQuantity: "",
        grnBalancePurchaseQuantity: "",
        currency: "",
        orderUnitOfMeasure: "",
        grnStatusItem: "New",
        supplierBatchNumber: "",
        plant: "",
        storeLocation: "",
        purchasingDocumentNr: "",
        purchasingDocumentItemNr: "",
        grossWeight: "",
        grnDeletionIndicator: "",
        cancellationRemarks: "",
        cancelledBy: "",
        cancelledOn: "",
        cancelledTime: "",
        rejectedQuantity: "",
        rejectedRemarks: "",
      },
    ],
  });

  useEffect(() => {
    const calculatedTotal = (
      Number(subTotalValue || 0) +
      Number(getOtherChargesValue || 0) +
      Number(formInputs.vendorTaxValue || 0) +
      Number(formInputs.vendorFreightValue || 0)
    ).toFixed(2);

    // Update the state so the input field shows the new total
    setFormInputs((prev) => ({
      ...prev,
      vendorTotalInvoiceValue: calculatedTotal,
    }));

    // Dependencies: whenever these change, the total updates
  }, [
    subTotalValue,
    getOtherChargesValue,
    formInputs.vendorTaxValue,
    formInputs.vendorFreightValue,
  ]);

  const PriceSheduleColumns = [
    {
      name: "GRN Item Nr",
      selector: (row) => row.grnItemNr,
      sortable: true,
      width: "130px",
    },
    {
      name: "PO Item Nr",
      selector: (row) => row.purchasingDocumentItemNr,
      sortable: true,
      width: "120px",
    },
    {
      name: "Material/Service",
      selector: (row) => row.materialCode,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row.materialCode} </p>
            <p className="m-0 p-0">{row.materialDescription} </p>
          </div>
        </>
      ),
      width: "180px",
      sortable: true,
    },
    {
      name: "Purchase Qty",
      selector: (row) => row.purchaseQuantity,
      cell: (row) => (
        <>
          <InputField
            className="inputBox mt-1"
            name="purchaseQuantity"
            value={row.purchaseQuantity}
            disabled={true}
          />
        </>
      ),
      sortable: true,
      width: "150px",
    },
    subTransactionActivity === "ASN" && {
      name: "ASN Qty",
      selector: (row) => row.asnQuantity,
      cell: (row) => (
        <>
          <InputField
            className="inputBox mt-1"
            name="asnQuantity"
            value={row.asnQuantity}
            disabled={true}
          />
        </>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "GRN Qty",
      cell: (row) => (
        <>
          <InputField
            type="number"
            className="inputBox mt-1"
            id="grnQuantity"
            name="grnQuantity"
            value={row.grnQuantity}
            onChange={(e) =>
              subTransactionActivity === "ASN"
                ? handleInputChangeTableASN(
                    row.local_id,
                    e.target.value,
                    row.asnQuantity,
                    (row.unitPrice ?? row.orderPriceUnit),
                    row.tempAsnBalancePurchaseQuantity
                  )
                : handleInputChangeTableGRN(
                    row.local_id,
                    e.target.value,
                    row.purchaseQuantity,
                    (row.unitPrice ?? row.orderPriceUnit),
                    row?.grn?.grnBalancePurchaseQuantity
                  )
            }
            disabled={
              (subTransactionActivity === "ASN"
                ? row.tempAsnBalancePurchaseQuantity
                : row?.grn?.grnBalancePurchaseQuantity) === 0
                ? true
                : false
            }
          />
        </>
      ),
      sortable: true,
      width: "160px",
    },
{
  name: "Rejected Qty",
  selector: (row) => row.rejectedQuantity,
  cell: (row) => (
    <InputField
      type="number"
      className="inputBox mt-1"
      name="rejectedQuantity"
      value={row.rejectedQuantity}
      disabled={Number(row.grnQuantity || 0) === 0}
      onChange={(e) => {
        let value = Number(e.target.value || 0);
        const grnQty = Number(row.grnQuantity || 0);

        //  negative allow cheyyakudadhu
        if (value < 0) value = 0;

        // GRN qty kanna ekkuva allow cheyyakudadhu
        if (value > grnQty) value = grnQty;

        //  equal (1=1, 2=2) perfectly allowed
        handleRejectedChange(
          row.local_id,
          "rejectedQuantity",
          value
        );
      }}
    />
  ),
  width: "150px",
},

 {
  name: "Rejected Remarks",
  cell: (row) => (
    <InputField
      className="inputBox mt-1"
      name="rejectedRemarks"
      value={row.rejectedRemarks}
      disabled={Number(row.rejectedQuantity) <= 0}
      placeholder={"Enter rejection reason"}
      onChange={(e) =>
        handleRejectedChange(
          row.local_id,
          "rejectedRemarks",
          e.target.value
        )
      }
    />
  ),
  width: "200px",
},


    {
      name: "Balance Qty",
      cell: (row) => (
        <>
          <InputField
            className="inputBox mt-1"
            name={
              subTransactionActivity === "ASN"
                ? "asnBalancePurchaseQuantity"
                : "grnBalancePurchaseQuantity"
            }
            value={
              (subTransactionActivity === "ASN"
                ? row.asnBalancePurchaseQuantity
                : row.grnBalancePurchaseQuantity) || 0
            }
            disabled={true}
          />
        </>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Oder Unit",
      selector: (row) => row?.unit || row.orderUnitOfMeasure,
      sortable: true,
      width: "120px",
    },
    {
      name: "Unit Price",
      // selector: (row) => row.orderPriceUnit,
      cell: (row) => (
        <span className="numberFormate fw fw-bold">
          {currencyFormat(Number(row.unitPrice || row.orderPriceUnit).toFixed(2))}
        </span>
      ),

      sortable: true,
      width: "160px",
    },
    {
      name: "Item Value",
      selector: (row) => row.totalPrice,
      cell: (row) => (
        <>
          <InputField
            className="inputBox mt-1"
            name="totalPrice"
            value={row.totalPrice || 0}
            disabled={true}
          />
        </>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Currency",
      selector: (row) => row.currencyCode || "INR",
      sortable: true,
      width: "120px",
    },
    {
      name: "Delivery Date",
      selector: (row) => row.deliveryDate,
      sortable: true,
      width: "140px",
    },
    {
      name: "Gst Amount",
      selector: (row) => row.taxAmount,
      sortable: true,
      width: "130px",
    },
    // {
    //   name: "Storage Location",
    //   selector: (row) => row.storageLocation,
    //   sortable: true,
    //   width: "180px",
    // },
    {
  name: "Storage Location",
  selector: (row) => row.storageLocation,
  sortable: true,
  width: "180px",
  cell: (row) => {
    const value = row.storageLocation;

    const color =
      value === "Rent"
        ? "red"
        : value === "Sale"
        ? "green"
        : "inherit";

    return (
      <span style={{ color, fontWeight: 600 }}>
        {value}
      </span>
    );
  },
}
  ];


  const handleInputChangeTableGRN = (
    id,
    value,
    purchaseQuantity,
    orderPriceUnit,
    unitPrice,
    grnBalancePurchaseQuantity,
  ) => {
   
    if (Number(purchaseQuantity) >= Number(value)) {
      let totalPriceVal = Number(unitPrice ?? orderPriceUnit) * Number(value);

      const updatedData = itemTableData.map((item) => {
        if (item.local_id !== id) return item;

        // const balanceQty = grnBalancePurchaseQuantity
        //   ? Number(item.grn?.grnBalancePurchaseQuantity || purchaseQuantity) -
        //     Number(value)
        //   : Number(purchaseQuantity) - Number(value);

//         let  balanceQty = item.grn?.grnBalancePurchaseQuantity
//         if (item.grn?.grnBalancePurchaseQuantity){

//      balanceQty = Number(purchaseQuantity) - Number(value)
//            }else{
// balanceQty = Number(item.grn?.grnBalancePurchaseQuantity ?? 0) -
//             Number(value)
//         }

const baseQty = item.grn?.grnBalancePurchaseQuantity ?? purchaseQuantity;

const balanceQty = Number(baseQty) - Number(value);


        return {
          ...item,
          grnQuantity: Number(value),
          grnBalancePurchaseQuantity: balanceQty,
          totalPrice: totalPriceVal,
          grnBalancePurchaseQuantity1:balanceQty,

          // ✅ LINE ITEM STATUS
          grnStatus:
            Number(value) === Number(purchaseQuantity)
              ? "Fully Received"
              : "Partially Received",
        };
      });

      setItemTableData(updatedData);
      getTotalCount(updatedData);
      updateGrnHeaderStatus(updatedData);
    }
  };
  const updateGrnHeaderStatus = (data) => {
    const validItems = data.filter(
      (item) => item.grnQuantity !== null && item.grnQuantity !== ""
    );

    const isFullyReceived =
      validItems.length > 0 &&
      validItems.every(
        (item) => Number(item.grnQuantity) === Number(item.purchaseQuantity)
      );

    formInputs.grnStatus = isFullyReceived
      ? "Fully Received"
      : "Partially Received";
  };

  const handleInputChangeTableASN = (
    id,
    value,
    asnQuantity,
    orderPriceUnit,
    unitPrice,
    tempAsnBalancePurchaseQuantity
  ) => {
    if (Number(asnQuantity) >= Number(value)) {
      let totalPriceVal = Number((unitPrice ?? orderPriceUnit)) * Number(value);

      if (tempAsnBalancePurchaseQuantity) {
        if (Number(value) <= Number(tempAsnBalancePurchaseQuantity)) {
          const updatedData = itemTableData.map((item) => {
            return item.local_id === id
              ? {
                  ...item,
                  grnQuantity: Number(value),
                  asnBalancePurchaseQuantity: item.asnBalancePurchaseQuantity
                    ? Number(item.tempAsnBalancePurchaseQuantity) -
                      Number(value)
                    : Number(asnQuantity) - Number(value),
                  totalPrice: totalPriceVal,
                }
              : item;
          });

          setItemTableData(updatedData);
          getTotalCount(updatedData);
        }
      } else {
        const updatedData = itemTableData.map((item) => {
          return item.local_id === id
            ? {
                ...item,
                grnQuantity: Number(value),
                asnBalancePurchaseQuantity: Number(asnQuantity) - Number(value),
                totalPrice: totalPriceVal,
              }
            : item;
        });

        setItemTableData(updatedData);
        getTotalCount(updatedData);
      }
    } else {
      // console.log("Do Nothing");
    }
  };

  // Get Total for SubTotal Pricing Schedule
  const getTotalCount = (data) => {
    const getTotal = data.reduce(
      (accumulator, currentValue) =>
        accumulator + (currentValue?.totalPrice || 0),
      0
    );
    setSubTotalValue(getTotal);
  };

  // Core Logic
  const loadInitalPageData = async () => {
    setLoading(true);

    if (subTransactionActivity === "ASN") {
      if (asnNumber) {
        let filteredData = asn_data.filter(
          (item) => item.asnNumber === asnNumber
        );
        // console.log(">> filteredData GRN ", filteredData);
        setHeaderData(filteredData[0]);
        let itemData = filteredData[0]?.items;

        const updateditemData = itemData.map((obj, index) => ({
          ...obj,
          grnItemNr: index + 1,
          purchasingDocumentNr: obj.purchasingDocumentNr,
          tempAsnBalancePurchaseQuantity: obj.asnBalancePurchaseQuantity,
          asnQuantity: Number(obj.asnQuantity),
          purchaseQuantity: Number(obj.purchaseQuantity),
          grnStatusItem: "In Transit",
        }));

        setItemTableData(updateditemData);
        setLoading(false);
      } else {
        // navigate(Constants.POCOLLABRATION_PURCHASE_ORDER_LIST);
        window.history.back();
      }
    } else if (subTransactionActivity === "PO") {
      if (poNumber) {
        setHeaderData(selectedPoDetails);
        let itemData = selectedPoDetails?.items;

        const updateditemData = itemData.map((obj, index) => ({
          ...obj,
          grnItemNr: index + 1,
          purchasingDocumentNr: poNumber,
          grnStatusItem: "In Transit",
        }));

        setItemTableData(updateditemData);
        setLoading(false);
      } else {
        // navigate(Constants.POCOLLABRATION_PURCHASE_ORDER_LIST);
        window.history.back();
      }
    } else {
      window.history.back();
    }
  };

  useEffect(() => {
    loadInitalPageData(); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [poNumber, selectedPoDetails]);

//   const handleSave = async () => {
//     // 2️ Rejected Qty should NOT be greater than GRN Qty
//     if (
//     !formInputs.vendorInvoiceNo ||
//     !formInputs.vendorInvoiceDate ||
//     !formInputs.ewayBillNumber
//   ) {
//     toast.error(
//       "Please enter Invoice Number, Invoice Date and E-way Bill Number.",
//       {
//         position: "top-right",
//         duration: 4000,
//       }
//     );
//     return;
//   }
//     const hasEnteredGrnQty = itemTableData.some(
//       (item) => Number(item.grnQuantity) > 0
//     );

//     if (!hasEnteredGrnQty) {
//       toast.error("Please enter GRN Quantity for at least one item.", {
//         position: "top-right",
//         duration: 4000,
//       });
//       return;
//     }
 
    
//     const toastId = toast.loading("Loading...", {
//       position: "top-right",
//     });
    
    

//     // try {
//       // formInputs.items = itemTableData;

//       // const validItems = itemTableData.filter(
//       //   (item) => item.grnQuantity !== null && item.grnQuantity !== ""
//       // );

//       // const isFullyReceived = validItems.every((item) => {
//       //   return Number(item.grnBalancePurchaseQuantity) === 0;
//       // });

//      try {
//     const finalItems = itemTableData.map((item) => ({
//   ...item,
//   rejectedQuantity: Number(item.rejectedQuantity || 0),
//   rejectedRemarks: item.rejectedRemarks || "",
  
// }));


//     formInputs.items = finalItems;

//     const validItems = finalItems.filter(
//       (item) => item.grnQuantity !== null && item.grnQuantity !== ""
//     );

//     const isFullyReceived = validItems.every(
//       (item) => Number(item.grnBalancePurchaseQuantity) === 0
//     );

//       formInputs.grnStatus = isFullyReceived
//         ? "Fully Received"
//         : "Partially Received";

//       formInputs.vendorCode = getHeaderData.vendorCode;
//       formInputs.vendorName = getHeaderData.vendorName;
//       formInputs.deliveredValue = getHeaderData.deliveredValue;
//       formInputs.deliveredStatus = getHeaderData.deliveredStatus;
//       formInputs.invoicedValue = getHeaderData.invoicedValue;
//       formInputs.invoicedStatus = getHeaderData.invoicedStatus;
//       formInputs.paidValue = getHeaderData.paidValue;
//       formInputs.vendorInvoiceCurrency = getHeaderData.currencyCode;
//       formInputs.purchasingDocumentDate = getHeaderData.purchasingDocumentDate;
//       formInputs.incoTerms = getHeaderData.incoTerms;
//       formInputs.paymentTerms = getHeaderData.paymentTerms;
//       formInputs.purchasingDocumentValue =
//         getHeaderData.purchasingDocumentValue;
//       formInputs.currency = getHeaderData.currency;
//       formInputs.currencyCode = getHeaderData.currencyCode;
//       formInputs.sumOfGrn = subTotalValue;
//       formInputs.vendorMobileNo = getHeaderData.vendorMobileNo;
//       formInputs.vendorEmail = getHeaderData.vendorEmail;
//       formInputs.vendorAddress = getHeaderData.vendorAddress;
//       formInputs.invoiceData = invoiceData;
//       formInputs.vendorTotalInvoiceValue = (
//         Number(subTotalValue || 0) +
//         Number(getOtherChargesValue || 0) +
//         Number(formInputs.vendorTaxValue || 0) +
//         Number(formInputs.vendorFreightValue || 0)
//       ).toFixed(2);

//       let obj = {
//         data: formInputs,
//       };
//       let obj1= {
        

//     grnVendorInvoiceNo: formInputs?.vendorInvoiceNo,
//     grnVendorInvoiceDate:formInputs?.vendorInvoiceDate,
//     grnVendorTotalInvoiceValue:formInputs?.vendorTotalInvoiceValue,
//     grnTotalInvoiceValue:TotalInvoiceValue,
//     grnGstValue:gstValue,
//     grnDebitNote:debitNote,
//     grnEwayBillNumber:formInputs.ewayBillNumber,
//     grnEwayBillExpiryDate:formInputs.ewayBillExpiryDate,
//     grnEwayBillExpiryTime:formInputs.ewayBillExpiryTime,
//     grnShippingDocuments:formInputs.shippingDocuments,
//     grnOtherAttachments:formInputs?.otherAttachments
      
           
//       }
//       console.log("obj",obj)
//       console.log("obj1",obj1)

//       setDisabled(true);

//       const response = await ItemService.addGRN(obj);
//       const response2 = await CustomerService.updatePODocs(obj);

//       if (response?.status === 200 && response2?.status === 200) {
//         modalData.successMsg = response?.message;
//         setModalInfo(modalData);
//         onSuccessfullyRegistered();

//         // Refresh GRN List
//         dispatch(getGoodsReceivedNote());
//       } else {
//         toast.error(response?.message || "Please try again !!", {
//           duration: 4000,
//           position: "top-right",
//         });
//       }
//     } catch (error) {
//       toast.error("Something went wrong. Please try again.", {
//         duration: 4000,
//         position: "top-right",
//       });
//     } finally {
//       toast.dismiss(toastId);
//       setDisabled(false);
//     }
//   };


const handleSave = async () => {
  // 🔴 Required field validation
  if (
    !formInputs.vendorInvoiceNo ||
    !formInputs.vendorInvoiceDate ||
    !formInputs.ewayBillNumber
  ) {
    toast.error(
      "Please enter Invoice Number, Invoice Date and E-way Bill Number.",
      {
        position: "top-right",
        duration: 4000,
      }
    );
    return;
  }

  // 🔴 At least one GRN qty required
  const hasEnteredGrnQty = itemTableData.some(
    (item) => Number(item.grnQuantity) > 0
  );

  if (!hasEnteredGrnQty) {
    toast.error("Please enter GRN Quantity for at least one item.", {
      position: "top-right",
      duration: 4000,
    });
    return;
  }

  // 🔴 Rejected Qty validation
  const invalidRejected = itemTableData.some(
    (item) =>
      Number(item.rejectedQuantity || 0) > Number(item.grnQuantity || 0)
  );

  if (invalidRejected) {
    toast.error("Rejected Quantity should not be greater than GRN Quantity.", {
      position: "top-right",
      duration: 4000,
    });
    return;
  }

  const toastId = toast.loading("Loading...", {
    position: "top-right",
  });

  try {
    // ✅ Prepare final items
    const finalItems = itemTableData.map((item) => ({
      ...item,
      rejectedQuantity: Number(item.rejectedQuantity || 0),
      rejectedRemarks: item.rejectedRemarks || "",
    }));

    const validItems = finalItems.filter(
      (item) => item.grnQuantity !== null && item.grnQuantity !== ""
    );

    const isFullyReceived = validItems.every(
      (item) => Number(item.grnBalancePurchaseQuantity) === 0
    );

    // ✅ Prepare payload (NO mutation)
    const payload = {
      ...formInputs,
      items: finalItems,
      grnStatus: isFullyReceived
        ? "Fully Received"
        : "Partially Received",

      vendorCode: getHeaderData.vendorCode,
      vendorName: getHeaderData.vendorName,
      deliveredValue: getHeaderData.deliveredValue,
      deliveredStatus: getHeaderData.deliveredStatus,
      invoicedValue: getHeaderData.invoicedValue,
      invoicedStatus: getHeaderData.invoicedStatus,
      paidValue: getHeaderData.paidValue,
      vendorInvoiceCurrency: getHeaderData.currencyCode,
      purchasingDocumentDate: getHeaderData.purchasingDocumentDate,
      incoTerms: getHeaderData.incoTerms,
      paymentTerms: getHeaderData.paymentTerms,
      purchasingDocumentValue: getHeaderData.purchasingDocumentValue,
      currency: getHeaderData.currency,
      currencyCode: getHeaderData.currencyCode,
      sumOfGrn: subTotalValue,
      vendorMobileNo: getHeaderData.vendorMobileNo,
      vendorEmail: getHeaderData.vendorEmail,
      vendorAddress: getHeaderData.vendorAddress,
      invoiceData: invoiceData,
      debitNote:formInputs.debitNote,
grnGstValue:gstValue,
      vendorTotalInvoiceValue: (
        Number(subTotalValue || 0) +
        Number(getOtherChargesValue || 0) +
        Number(formInputs.vendorTaxValue || 0) +
        Number(formInputs.vendorFreightValue || 0)
      ).toFixed(2),
    };

    // ✅ API payloads
    const obj = { data: payload };

    const obj1 = {
      documentNumber: payload?.purchasingDocumentNr,
    purchasingDocumentNr: payload?.purchasingDocumentNr,
      grnVendorInvoiceNo: payload.vendorInvoiceNo,
      grnVendorInvoiceDate: payload.vendorInvoiceDate,
      grnVendorTotalInvoiceValue: payload.vendorTotalInvoiceValue,
      grnTotalInvoiceValue: TotalInvoiceValue,
      grnGstValue: gstValue,
      grnDebitNote: debitNote,
      grnEwayBillNumber: payload.ewayBillNumber,
      grnEwayBillExpiryDate: payload.ewayBillExpiryDate,
      grnEwayBillExpiryTime: payload.ewayBillExpiryTime,
      grnShippingDocuments: payload.shippingDocuments,
      grnOtherAttachments: payload.otherAttachments,
    };


    setDisabled(true);

    // ✅ API calls
    const response1 = await ItemService.addGRN(obj);
    const response2 = await CustomerService.updatePODocs(obj1);

    // ✅ Success check
    if (response1?.status === 200 && response2?.status === 200) {
      modalData.successMsg = response1?.message || "GRN Created Successfully";
      setModalInfo(modalData);
      onSuccessfullyRegistered();

      dispatch(getGoodsReceivedNote());
    } else {
      toast.error(
        response1?.message ||
          response2?.message ||
          "One of the operations failed. Please try again.",
        {
          duration: 4000,
          position: "top-right",
        }
      );
    }
  } catch (error) {
    console.error(error);
    toast.error("Something went wrong. Please try again.", {
      duration: 4000,
      position: "top-right",
    });
  } finally {
    toast.dismiss(toastId);
    setDisabled(false);
  }
};
  /* Show Success Modal */
  // eslint-disable-next-line
  const onSuccessfullyRegistered = () => {
    setShowSuccessModal(true);
  };
  const hideSuccessModal = () => {
    setShowSuccessModal(false);
  };

  // For Upload Success
  const onSuccessUploadDocumentType = (data) => {
    setFormInputs((formInputs) => ({
      ...formInputs,
      [data.fieldName]: data.attachmentId,
    }));
  };

  // View attachment files
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  const [invoiceData, setInvoiceData] = useState([]);
  /* Header text selected data */
  const [getHeaderTextSelectedData, setHeaderTextSelectedData] = useState([]);
  const handleHeaderTextSelectedData = (data) => {
    setHeaderTextSelectedData(data);
  };
  const [HeaderTextModel, setHeaderTextModel] = useState(false);
  /* Create Header Text Modal Function */
  // eslint-disable-next-line
  const showsetHeaderText = () => {
    setHeaderTextModel(true);
  };
  const hideHeaderTextModel = () => {
    setHeaderTextModel(false);
  };

  useEffect(() => {
    const getTotal = getHeaderTextSelectedData.reduce(
      (accumulator, currentValue) =>
        accumulator + Number(currentValue?.documentText || 0),
      0
    );
    setOtherChargesValue(getTotal);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getHeaderTextSelectedData]);

  const addInvoiceDocument = () => {
    // Create a new document with some data (you can customize the content)
    const newDocument = {
      id: Date.now(),
      name: `Document ${invoiceData.length + 1}`,
    };
    // Update the state with the new document
    setInvoiceData((prevData) => [...prevData, newDocument]);
  };

  const deleteInvoiceDocument = (id) => {
    // Filter out the document with the given id
    const updatedData = invoiceData.filter((doc) => doc.id !== id);
    // Update the state with the remaining documents
    setInvoiceData(updatedData);
  };

  //for on succesfull document
  const onSuccessUploadDocumentTypeInvoice = (data) => {
    setInvoiceData((prevData) =>
      prevData.map((doc) =>
        doc.id === data.fieldId
          ? { ...doc, [data.fieldName]: data.attachmentId }
          : doc
      )
    );
  };

  const netValue = Number(getHeaderData?.purchasingDocumentValue || 0);

  const vendorTotalInvoiceValue =
    Number(subTotalValue || 0) +
    Number(getOtherChargesValue || 0) +
    Number(formInputs.vendorTaxValue || 0) +
    Number(formInputs.vendorFreightValue || 0);
  // eslint-disable-next-line
  const debitNoteValue = (netValue - vendorTotalInvoiceValue).toFixed(2);

 
  const TotalInvoiceValue = Number(getHeaderData?.purchasingDocumentValue || 0);

  const purchasingValue = Number(getHeaderData?.purchasingDocumentValue || 0);

  const vendorInvoiceValue = Number(formInputs?.vendorTotalInvoiceValue || 0);

  const gstValue = Number(
    getHeaderData?.items?.reduce(
      (sum, item) => sum + Number(item?.taxAmount || 0),
      0
    ) || 0
  );

  const totalInvoiceWithGST = vendorInvoiceValue + gstValue;

  const debitNote =
    purchasingValue === totalInvoiceWithGST
      ? "0.00"
      : Math.max(purchasingValue - totalInvoiceWithGST, 0).toFixed(2);
 


  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} lg={12} className="rightSide quoation">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={12} lg={12} className="mb-2">
                <h2 className="mainTitle">
                  {subTransactionActivity === "ASN" && (
                    <>
                      Create GRN for
                      <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                        {getHeaderData?.purchasingDocumentNr}
                      </span>
                      <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                        {asnNumber}
                      </span>
                      <span>
                        {getHeaderData?.asnStatusHeader === "ASN Cancelled" ? (
                          <span className="bg-table-status bg-table-danger-status headerStatusDetailedPage">
                            {getHeaderData?.asnStatusHeader}
                          </span>
                        ) : getHeaderData?.asnStatusHeader === "In Transit" ? (
                          <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                            {getHeaderData?.asnStatusHeader}
                          </span>
                        ) : getHeaderData?.asnStatusHeader ===
                          "Gatepass Created" ? (
                          <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                            {getHeaderData?.asnStatusHeader}
                          </span>
                        ) : (
                          getHeaderData?.asnStatusHeader
                        )}
                      </span>
                    </>
                  )}
                  {subTransactionActivity === "PO" && (
                    <>
                      Create GRN for{" "}
                      <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                        {getHeaderData?.purchasingDocumentNr}
                      </span>
                      <span>
                        {getHeaderData?.statusHeader === "New" ? (
                          <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                            {getHeaderData?.statusHeader}
                          </span>
                        ) : getHeaderData?.statusHeader === "In Release" ? (
                          <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                            {getHeaderData?.statusHeader}
                          </span>
                        ) : getHeaderData?.statusHeader === "Acknowledged" ? (
                          <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                            {getHeaderData?.statusHeader}
                          </span>
                        ) : (
                          getHeaderData?.statusHeader
                        )}
                      </span>
                    </>
                  )}
                </h2>
                <p className="subText">Fill GRN Details</p>
              </Col>
              <hr />
            </Row>
            {/*Document Header Details */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">DH</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">
                        {" "}
                        Document Header Details
                      </span>
                      <span className="subHeaderTitle">
                        Purchase Order Header Details
                      </span>
                    </Col>

                    <Col xs={2} md={1} lg={1} className="">
                      <POCollabrationCommonFillter />
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="PO Document Nr"
                          name="purchasingDocumentNr"
                          placeholder=""
                          value={getHeaderData?.purchasingDocumentNr}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>

                      {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Status:"
                          name="statusHeader"
                          placeholder=""
                          value={getHeaderData?.statusHeader}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col> */}

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Document Date"
                          name="purchasingDocumentDate"
                          placeholder=""
                          value={getHeaderData?.purchasingDocumentDate}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>

                      {/* {getHeaderData?.purchasingDocumentValue && ( */}
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Net Value"
                          name="purchasingDocumentValue"
                          placeholder=""
                          value={`${currencyFormat(
                            Number(
                              getHeaderData?.purchasingDocumentValue
                            ).toFixed(2)
                          )} INR`}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Vendor Code"
                          name="vendorCode"
                          id="vendorCode"
                          value={getHeaderData?.vendorCode}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Vendor Name"
                          name="vendorName"
                          id="vendorName"
                          value={getHeaderData?.vendorName}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <TextAreaField
                          id="vendorAddress"
                          className="inputBox"
                          label="Vendor Address"
                          name="vendorAddress"
                          placeholder=""
                          value={getHeaderData?.vendorAddress || ""}
                          disabled={true}
                          onChange={onInputChange}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          id="vendorEmail"
                          className="inputBox"
                          label="Vendor Email"
                          name="vendorEmail"
                          placeholder=""
                          value={getHeaderData?.vendorEmail || ""}
                          disabled={true}
                          onChange={onInputChange}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          id="vendorMobileNo"
                          className="inputBox"
                          label="Vendor Mobile"
                          name="vendorMobileNo"
                          placeholder=""
                          value={getHeaderData?.vendorMobileNo || ""}
                          disabled={true}
                          onChange={onInputChange}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Payment Terms"
                          name="incopaymentTermsTerms"
                          id="paymentTerms"
                          value={getHeaderData?.paymentTerms}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Transaction Activity"
                          name="subTransactionActivity"
                          id="subTransactionActivity"
                          value={subTransactionActivity}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col> */}
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="GRN Total Amount"
                          name="sumOfGrn"
                          id="sumOfGrn"
                          value={subTotalValue}
                          // onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>

                      {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Bill Of Lading"
                          name="billOfLading"
                          id="billOfLading"
                          value={formInputs.billOfLading}
                          onChange={onInputChange}
                          disabled={false}
                        />
                      </Col> */}
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <TextAreaField
                          className="inputBox"
                          label="Delivery/GRN Remarks "
                          name="grnRemark"
                          value={formInputs.grnRemark}
                          onChange={onInputChange}
                          disabled={false}
                          required={true}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* Price Shedule / Line Item */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">PI</span>
                    </Col>
                    <Col xs={8} md={6} lg={6}>
                      <span className="headerTitle">
                        Price Shedule / Line Item
                      </span>
                      <span className="subHeaderTitle">
                        Price Shedule / Line Item
                      </span>
                    </Col>
                    {/* <Col xs={4} md={2} lg={2} className="">
                      <button className="btnTable">
                        <i className="bi bi-file-excel"></i>Template
                      </button>
                    </Col>
                    <Col xs={4} md={2} lg={2} className="">
                      <button
                        className="btnTable"
                        onClick={() => {
                          alert("asd");
                        }}
                      >
                        <i className="bi bi-file-excel"></i> Upload
                      </button>
                    </Col> */}
                    <Col xs={2} md={1} lg={1} className="">
                      <POCollabrationCommonFillter />
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          // title=""
                          columns={PriceSheduleColumns}
                          data={itemTableData}
                          progressPending={loading}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/*grn attachments*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible3
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">QH</span>
                    </Col>
                    <Col xs={12} md={9} lg={9}>
                      <span className="headerTitle">GRN Attachment</span>
                      <span className="subHeaderTitle">GRN Attachment</span>
                    </Col>

                    <Col xs={2} md={1} lg={1} className="">
                      <POCollabrationCommonFillter />
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible3 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4 d-flex justify-content-between">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <FileUploadComponentForHB
                          id="shippingDocuments"
                          name="shippingDocuments"
                          label="Shipping Documents"
                          allowedTypes={[
                            "image/png",
                            "image/jpeg",
                            "application/pdf",
                          ]}
                          multiple={true}
                          onSuccessUpload={onSuccessUploadDocumentType}
                          value={formInputs?.shippingDocuments || ""}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={1}
                        lg={1}
                        className="commTopButtonRightLeftPadding d-flex align-items-center"
                      >
                        {formInputs?.shippingDocuments ? (
                          <img
                            src="assets/img/newIcons/attached-file.png"
                            className="mt-1 attachmentIcon"
                            alt="attachments"
                            onClick={() =>
                              handleViewFile(formInputs?.shippingDocuments)
                            }
                          />
                        ) : (
                          "--"
                        )}
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <FileUploadComponentForHB
                          id="otherAttachments"
                          name="otherAttachments"
                          label="Other Attachments"
                          allowedTypes={[
                            "image/png",
                            "image/jpeg",
                            "application/pdf",
                          ]}
                          multiple={true}
                          onSuccessUpload={onSuccessUploadDocumentType}
                          value={formInputs?.otherAttachments || ""}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={1}
                        lg={1}
                        className="commTopButtonRightLeftPadding d-flex align-items-center"
                      >
                        {formInputs?.otherAttachments ? (
                          <img
                            src="assets/img/newIcons/attached-file.png"
                            className="mt-1 attachmentIcon"
                            alt="attachments"
                            onClick={() =>
                              handleViewFile(formInputs?.otherAttachments)
                            }
                          />
                        ) : (
                          "--"
                        )}
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* invoice details */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">ID</span>
                    </Col>

                    <Col xs={4} md={8} lg={8}>
                      <span className="headerTitle"> Invoice details</span>
                      <span className="subHeaderTitle">Invoice details</span>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="">
                      <POCollabrationCommonFillter />
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <Row className="pt-2 pb-4">
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Invoice Number"
                                name="vendorInvoiceNo"
                                id="vendorInvoiceNo"
                                value={formInputs.vendorInvoiceNo}
                                onChange={onInputChange}
                                disabled={false}
                                required={true}
                                // error={validation.vendorInvoiceNo}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Invoice Date"
                                name="vendorInvoiceDate"
                                id="vendorInvoiceDate"
                                type="date"
                                value={formInputs.vendorInvoiceDate}
                                onChange={onInputChange}
                                disabled={false}
                                required={true}
                                // error={validation.vendorInvoiceNo}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                type="text"
                                label="Invoice Value"
                                name="vendorTotalInvoiceValue"
                                placeholder="0.00"
                                id="vendorTotalInvoiceValue"
                                // Look ONLY at the state variable
                                value={
                                  formInputs?.vendorTotalInvoiceValue || ""
                                }
                                onChange={onInputChange}
                                disabled={false}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                type="text"
                                label="Total Invoice Value"
                                name="totalInvoiceValue"
                                value={TotalInvoiceValue}
                                disabled
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                type="text"
                                label="Gst Value"
                                name="gstValue"
                                id="gstValue"
                                placeholder=""
                                value={gstValue}
                                onChange={onInputChange}
                                // disabled={true}
                                required={true}
                                disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                type="text"
                                label="Debit Note"
                                name="debitNote"
                                value={debitNote}
                                onChange={onInputChange}
                                disabled
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="E-way Bill Nr"
                                name="ewayBillNumber"
                                id="ewayBillNumber"
                                value={formInputs.ewayBillNumber}
                                onChange={onInputChange}
                                disabled={false}
                                required={true}
                                // error={validation.ewayBillNumber}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="E-way Bill Expiry Date"
                                name="ewayBillExpiryDate"
                                id="ewayBillExpiryDate"
                                type="date"
                                placeholder=""
                                value={formInputs.ewayBillExpiryDate || ""}
                                onChange={onInputChange}
                                // required={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="E-way Bill Expiry Time"
                                name="ewayBillExpiryTime"
                                id="ewayBillExpiryTime"
                                type="time"
                                placeholder=""
                                value={formInputs.ewayBillExpiryTime || ""}
                                onChange={onInputChange}
                                // required={true}
                              />
                            </Col>
                          </Row>
                          <hr className="mx-4 mb-3" />
                          <Row className="commLeftRightPadding">
                            <Col md={{ span: 3, offset: 9 }}>
                              <button
                                className="btn w-full"
                                onClick={addInvoiceDocument}
                              >
                                Add Document
                              </button>
                            </Col>
                          </Row>

                          <div className="d-flex-column justify-content-center">
                            <Row>
                              <Col xs={6} md={4} lg={4}>
                                <p className="fs-6 fw-medium d-flex justify-content-center w-25">
                                  File
                                </p>
                              </Col>
                              <Col xs={5} md={4} lg={4}>
                                <p className="fs-6 fw-medium d-flex justify-content-center w-20">
                                  View Files
                                </p>
                              </Col>
                              <Col xs={1} md={4} lg={4}>
                                <p className="fs-6 fw-medium d-flex justify-content-center w-25">
                                  Action
                                </p>
                              </Col>
                            </Row>
                            {invoiceData.map((doc, index) => (
                              <Row key={index}>
                                <Col xs={12} md={12} lg={12}>
                                  <hr className="mx-4 my-0 text-color-black" />
                                </Col>
                                <Col
                                  xs={5}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <FileUploadComponent
                                    id={doc.id}
                                    name="purchaseOrderFileAttachment"
                                    label="Customer PO"
                                    allowedTypes={[
                                      "image/png",
                                      "image/jpeg",
                                      "application/pdf",
                                    ]}
                                    multiple={true} // Change to false for single file selection
                                    required={true}
                                    onSuccessUpload={
                                      onSuccessUploadDocumentTypeInvoice
                                    }
                                    value={
                                      doc.purchaseOrderFileAttachment || ""
                                    }
                                  />
                                </Col>
                                <Col
                                  xs={5}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  {(doc.purchaseOrderFileAttachment && (
                                    <img
                                      src="assets/img/newIcons/attached-file.png"
                                      className="mt-1 attachmentIcon"
                                      alt="attachments"
                                      onClick={() =>
                                        handleViewFile(
                                          doc.purchaseOrderFileAttachment
                                        )
                                      }
                                    />
                                  )) ||
                                    "--"}
                                </Col>

                                <Col
                                  xs={2}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <i
                                    onClick={() =>
                                      deleteInvoiceDocument(doc.id)
                                    }
                                    className="bi bi-trash text-danger fs-4"
                                  />
                                </Col>
                              </Row>
                            ))}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* buttons */}
          <div className="pageFooter ">
            <Row className="rowDirection mb-4">
              <Col xs={12} md={2} lg={2} className="mb-4">
                <button
                  className="btn w-full"
                  onClick={handleSave}
                  disabled={disabled}
                >
                  <i className="bi bi-save"></i> Create
                </button>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>

      <SuccessRegisterModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        modaldata={getModalInfo}
        aftersuccess={
          subTransactionActivity === "ASN"
            ? Constants.POCOLLABRATION_ASN
            : CustomerConstants.CUSTOMER_V5_MR_POCOLLABRATION_GOODS_RECEIVED_NOTE
        }
      />
      <FileViewerModalForHB
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
        onDeleteSuccess={handleAttachmentDeleted}
      />
      {/* Header Text */}
      <HeaderText
        index={0}
        headername="Add Other Charges"
        show={HeaderTextModel}
        onHide={hideHeaderTextModel}
        hedertextdata={handleHeaderTextSelectedData}
        showcurrentdata={getHeaderTextSelectedData}
        masterdata="OtherChargesID"
        type="Number"
      />
       
    </main>
  );
};

export default CreateGRN;
